/**
 * Enum to define the different styles of message panels
 */
export enum MessagePanelType {
  INFO = "info", // Default
  SUCCESS = "success",
  WARNING = "warning",
  ERROR = "error"
}